import GPSelectMultiple from '@gp/components/SelectMultiple/index.old';
import { useRequestController } from '@sg/hooks/useRequestController';
import { getArraySort } from '@gp/utils/common';
import { isEmpty } from 'lodash-es';
import React, { FC, useMemo } from 'react';

interface Props {
  [key : string] : unknown;
}

const LiveMultipleSelectFilter: FC<Props> = ({
  value,
  onChange,
  responseFormatter,
  ...restProps
}) => {
  const { data, loading } = useRequestController({
    method: 'POST',
    url: '/api/v1/globalpedia_pc/cond',    staleTime: 300000,
    refreshDeps: useMemo(
      () => ({
        live_title_country_code: null,
        live_title_os: null,
        live_title_studio_game: null,
      }),
      [],
    ),
  });
  const list = useMemo(() => {
    const formatFn = responseFormatter
      ? responseFormatter(data)
      : getArraySort(data?.live_title_studio_game);
    const dataSource =
      formatFn?.map((t) => ({
        value: t?.studio || '',
        text: t?.studio || '-',
        label: t?.studio || '-',
        groupKey: 'separated',
      })) || [];
    return dataSource;
  }, [data, responseFormatter]);
  return (
    <GPSelectMultiple
      {...{
        style: { marginRight: 10 },
        label: 'Studio',
        placeholder: 'Please select Project',
        options: list,
        disabled: loading,
        searchable: true,
        onChange: (res) =>{
          // TODO: 如果啥也没有变化，终止掉
          if (isEmpty(value) && res?.length === list?.length) return;  
          onChange(res);
        },
        value,
        ...restProps,
      }}
    />
  );
};

export default LiveMultipleSelectFilter;
